export default __webpack_public_path__ + "static/media/AA4.32467fc5.jpg";